import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import PerDiemRatesBlock from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/PerDiemRates'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  divider?: boolean
  rightAction?: React.ReactNode
}

const PerDiemRates = (props: Props) => {
  const { rightAction } = props

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.per_diem_rates')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.per_diem_rates_subtitle')}
      divider={props.divider}
      rightAction={rightAction}
    >
      <PerDiemRatesBlock {...props} loading={false} />
    </FormBlock>
  )
}

export default PerDiemRates
